module.exports = __webpack_public_path__ + "static/area.7e8e54bdb37881c4e6de0f5a5122f96e.svg";